import { Box, TableCell, TableRow } from "@mui/material";

const ShimmerTableRow = ({ columnCount = 7, hideSelectAll = false, hideCheckbox = false }) => {
  // This component should mirror the structure used by DataTableHead/DataTableBody.
  // `columnCount` is expected to be the total number of cells in the row, including
  // the leading and trailing 60px cells when they are shown.

  const hasSideCells = !(hideSelectAll && hideCheckbox);
  const middleCellCount = columnCount - (hasSideCells ? 2 : 0);

  return (
    <TableRow data-testid="shimmer-row">
      {hasSideCells && (
        <TableCell
          sx={{
            width: "60px",
          }}
        >
          {!hideCheckbox && (
            <Box
              className="shimmer-content"
              sx={{ width: 24, height: 24, borderRadius: "4px" }}
            />
          )}
        </TableCell>
      )}

      {Array.from({ length: Math.max(0, middleCellCount) }).map((_, index) => (
        <TableCell
          className="custom-data-table-cell"
          key={index}
        >
          <Box className="shimmer-content" sx={{ width: "100%" }} />
        </TableCell>
      ))}

      {hasSideCells && (
        <TableCell
          sx={{
            width: "60px",
          }}
        />
      )}
    </TableRow>
  );
};

export default ShimmerTableRow;
